import { generateCrud } from './helpers'

export default function (id) {
  const path = `/api/surveys/${id}`

  return {
    convertToFolder: generateCrud(`${path}/convert_to_group`).create
  }
}
